import gql from 'graphql-tag'

export const fetchHPCartQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    delivery_date
    delivery_method
    id
    ship_to_id
    grand_total_your_price_details
    total_liters
    items {
      id
      uid
      quantity_from_fe
      product {
      volume_fe
        sku
        name
        catalog_product_name
        posm_multiplier_flag
        posm_multiplier_value
        image {
          url
        }
      }
      quantity_total
    }
    progress_bar_data {
      isFullTruck
      iMinimumOrderPallet
      iMaximumOrderPallet
      iMinimumOrderWeight
      iMaximumOrderWeight
      iMaximumOrderCash
      sOutletDeliveryMethod
      iTotalCartWeight
      iTotalCartPalletQty
      iMinLitersTank
      iMaxLitersTank
    }
  }
}
`)
